export default "<div [innerHTML]=\"message\" class=\"error text-center\" id=\"error-message\">\n</div>\n"